import { render, staticRenderFns } from "./AdminSecurityNotificationForm.vue?vue&type=template&id=2f77eb15&scoped=true&"
import script from "./AdminSecurityNotificationForm.vue?vue&type=script&lang=js&"
export * from "./AdminSecurityNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f77eb15",
  null
  
)

export default component.exports